import React, { useState } from 'react';
import { C, DEMO_OPTS } from '../data/constants';
import { NudgeLogo, PrimaryBtn, SelectButton } from './shared/UI';

const DEMO_FIELDS = [
  { key: 'age', label: 'Age Range' },
  { key: 'gender', label: 'Gender Identity' },
  { key: 'ethnicity', label: 'Race / Ethnicity' },
  { key: 'country', label: 'Country' },
  { key: 'education', label: 'Highest Education Completed' },
  { key: 'employment', label: 'Current Employment Status' },
  { key: 'income', label: 'Household Income (Annual)' },
  { key: 'marital', label: 'Marital Status' },
  { key: 'advice', label: 'Professional Financial Advice' },
];

export default function Demographics({ onComplete }) {
  const [answers, setAnswers] = useState({});

  const isExcluded = answers.advice === DEMO_OPTS.advice[0];
  const allAnswered = DEMO_FIELDS.every(f => answers[f.key] != null);
  const canProceed = allAnswered && !isExcluded;

  const handleSelect = (key, val) => {
    setAnswers(prev => ({ ...prev, [key]: val }));
  };

  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: "'DM Sans', sans-serif" }}>
      {/* Top bar */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 10,
        background: 'rgba(250,251,252,0.96)',
        backdropFilter: 'blur(8px)',
        borderBottom: `1px solid ${C.border}`,
        padding: '0 24px',
      }}>
        <div style={{ maxWidth: 760, margin: '0 auto', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <NudgeLogo size="sm" />
          <span style={{ fontSize: 13, color: C.muted, fontWeight: 500 }}>Step 2 of 4: Demographics</span>
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 24px 60px' }}>
        <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 30, color: C.navy, fontWeight: 400, marginBottom: 8 }}>
          About You
        </h1>
        <p style={{ color: C.muted, fontSize: 15, marginBottom: 36 }}>
          All responses are categorical — no exact figures are collected.
        </p>

        {DEMO_FIELDS.map(field => (
          <div key={field.key} style={{ marginBottom: 32 }}>
            <label style={{
              display: 'block', fontSize: 14, fontWeight: 600,
              color: C.text, marginBottom: 12,
            }}>
              {field.label}
            </label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {DEMO_OPTS[field.key].map(opt => (
                <button
                  key={opt}
                  onClick={() => handleSelect(field.key, opt)}
                  className="select-btn"
                  style={{
                    padding: '9px 16px',
                    borderRadius: 8,
                    border: answers[field.key] === opt ? `1.5px solid ${C.teal}` : `1px solid ${C.border}`,
                    background: answers[field.key] === opt ? C.tealLight : '#fff',
                    color: answers[field.key] === opt ? C.teal : C.text,
                    fontWeight: answers[field.key] === opt ? 600 : 400,
                    fontSize: 13,
                    cursor: 'pointer',
                    fontFamily: "'DM Sans', sans-serif",
                  }}
                >
                  {opt}
                </button>
              ))}
            </div>

            {/* Exclusion message */}
            {field.key === 'advice' && isExcluded && (
              <div style={{
                marginTop: 16,
                border: `1px solid ${C.gold}`,
                borderRadius: 10, padding: '16px 20px',
                background: '#fffbeb',
              }}>
                <p style={{ fontSize: 14, color: '#92400e', margin: 0, lineHeight: 1.65 }}>
                  <strong>Thank you for your interest.</strong> Participants currently receiving professional
                  financial advice are not eligible to join this study, as we need to measure the impact
                  of Nudge without pre-existing advisor relationships.
                </p>
              </div>
            )}
          </div>
        ))}

        <PrimaryBtn
          onClick={() => onComplete(answers)}
          disabled={!canProceed}
          fullWidth
          style={{ padding: '13px', fontSize: 15, marginTop: 8 }}
        >
          Continue to Baseline Survey
        </PrimaryBtn>
      </div>
    </div>
  );
}
